import CallToActionBanner from '@/components/CallToActionBanner';
import { PATH } from '@/constants/path';
import { JobSearchWebCriteria } from '@/types/jobs';
import React from 'react';

import styles from './JobListingRegisterCtaBanner.module.scss';

export type JobListingRegisterCtaBannerProps =
  | {
      suppressCTABanner: true;
    }
  | {
      suppressCTABanner?: false;
      isUserLoggedIn: boolean;
      position: number; // the index of this banner in the results list
      query: JobSearchWebCriteria; // the criteria for the search that resulted in this banner being shown
    };

const JobListingRegisterCtaBanner = (props: JobListingRegisterCtaBannerProps) => {
  if (props.suppressCTABanner) {
    return null;
  }
  const { isUserLoggedIn, position, query } = props;
  if (isUserLoggedIn) {
    return null;
  }

  return (
    <CallToActionBanner
      heading={'Access our free service, designed to save you time'}
      body={
        <ul>
          <li>Job searching is done for you</li>
          <li>Get told about jobs before they hit the market</li>
          <li>Travel and accommodation organized and paid for</li>
        </ul>
      }
      primaryCtaText={'REGISTER'}
      primaryCtaHref={PATH.REGISTER}
      className={styles.ctaBanner}
      dataTestId={'job-list-register-cta'}
      withLogo={true}
      trackingEvent={'Job Search Register CTA click'}
      trackingDetails={{
        position,
        grade: query.grade ?? 'none',
        speciality: query.speciality ?? 'none',
      }}
    />
  );
};

export default JobListingRegisterCtaBanner;
